// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__0rpox","MapBlock":"Footer_MapBlock__jgWtY","MapLink":"Footer_MapLink__fTYDb"};